import { route as c1Route } from "@faire/web-api/routes/category/c1CategoryUrlId";
import { route as c2Route } from "@faire/web-api/routes/category/c1CategoryUrlId/subcategory/c2CategoryUrlId";
import { route as c3Route } from "@faire/web-api/routes/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/c3CategoryUrlId";
import { route as productPageRoute } from "@faire/web-api/routes/product/productToken";
import { route as homepageRoute } from "@faire/web-api/routes/root";
import { route as searchRoute } from "@faire/web-api/routes/search";
import { pathMatchesRoute } from "@faire/web/common/routes/RouteMatcher";
import {
  ScrollDirection,
  useDetectScroll,
} from "@faire/web/ui/hooks/useDetectScroll";
import { LocationDescriptor } from "history";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { useIsLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";
import { useTopOfPageContent } from "@faire/retailer/stores/ui/useTopOfPageContent";

const isHideTopNavAllowedInRoute = (pathName: LocationDescriptor) => {
  const allowListForHideTopNav = [
    searchRoute,
    homepageRoute,
    productPageRoute,
    c1Route,
    c2Route,
    c3Route,
  ];
  return allowListForHideTopNav.some((route) =>
    pathMatchesRoute(pathName, route)
  );
};

export const useStickyNavContentPositions = (isLoading?: boolean) => {
  const pathName = useLocation();
  const { scrollDirection } = useDetectScroll("y", 5);
  // when user toggles the sidebar, we want to retain the original position of the top nav
  // we do set this value in "TopOfPageContentStore" when user toggles the sidebar:
  const { shouldKeepTopNavVisible: isTogglingSidebar } = useTopOfPageContent();

  const shouldHideTopNav = useIsLoggedInRetailer();

  const isHideTopNavAllowed = isHideTopNavAllowedInRoute(pathName);

  const scrollDirectionRef = useRef<ScrollDirection>(scrollDirection);
  scrollDirectionRef.current = scrollDirection;

  useEffect(() => {
    // there are many layout shifts when we toggle the sidebar. When we do that, last scroll should be "up" which will
    // retain the original position of the top nav. After this again its value will update based on scroll events:
    scrollDirectionRef.current = "up";
  }, [isTogglingSidebar]);

  return {
    shouldRetainOriginalPosition:
      !shouldHideTopNav ||
      isTogglingSidebar ||
      isLoading ||
      !isHideTopNavAllowed ||
      scrollDirectionRef.current === "up",
  };
};
